import { render } from "./4_Gebaeudehoehe.vue?vue&type=template&id=6059ba70"
import script from "./4_Gebaeudehoehe.vue?vue&type=script&lang=js"
export * from "./4_Gebaeudehoehe.vue?vue&type=script&lang=js"

import exportComponent from "/home/tristobombo/PHPStormProjects/ITW-webapp-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__